'use client';

import { CalendarEvent } from '@/lib/types';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Calendar as CalendarIcon, Clock, AlignLeft, Church } from 'lucide-react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { RichText } from '@/components/ui/rich-text';

interface EventDetailsProps {
    event: CalendarEvent;
    isOpen: boolean;
    onClose: () => void;
}

export function EventDetails({ event, isOpen, onClose }: EventDetailsProps) {
    
    const formatEventDate = () => {
        if (event.allDay) {
            if (format(event.start, 'yyyy-MM-dd') === format(event.end, 'yyyy-MM-dd')) {
                return format(event.start, "eeee, d 'de' MMMM", { locale: es });
            }
            return `${format(event.start, "d MMM", { locale: es })} - ${format(event.end, "d MMM", { locale: es })}`;
        }
        if (format(event.start, 'yyyy-MM-dd') === format(event.end, 'yyyy-MM-dd')) {
            return format(event.start, "eeee, d 'de' MMMM", { locale: es });
        }
        return `${format(event.start, "d MMM", { locale: es })} - ${format(event.end, "d MMM", { locale: es })}`;
    };

    const formatEventTime = () => {
        if (event.allDay) return "Todo el día";
        return `${format(event.start, "HH:mm")} - ${format(event.end, "HH:mm")}`;
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle className="text-2xl font-bold flex items-center gap-3">
                       <span className="w-4 h-6 rounded-full inline-block" style={{ backgroundColor: event.color || 'hsl(var(--primary))' }} />
                       {event.title}
                       {event.tipo === 'procesion' && (
                           <span className="flex items-center gap-1 rounded-full border border-amber-400/50 bg-amber-400/15 px-2 py-0.5 text-xs font-semibold text-amber-300">
                               <Church className="h-3.5 w-3.5" /> Procesión
                           </span>
                       )}
                    </DialogTitle>
                </DialogHeader>
                <div className="space-y-4 my-4">
                    <div className="flex items-center gap-3 text-muted-foreground">
                        <CalendarIcon className="h-5 w-5" />
                        <span className="font-medium">{formatEventDate()}</span>
                    </div>
                     <div className="flex items-center gap-3 text-muted-foreground">
                        <Clock className="h-5 w-5" />
                        <span>{formatEventTime()}</span>
                    </div>
                    {event.description && (
                        <div className="flex items-start gap-3 text-muted-foreground">
                            <AlignLeft className="h-5 w-5 mt-1" />
                            <RichText>{event.description}</RichText>
                        </div>
                    )}
                </div>
                 <DialogFooter>
                    <Button onClick={onClose}>Cerrar</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
